import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/setup")) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function getUser() {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setAuth(token, user) {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
}

export const STATUS_LABEL = {
  neu: "Neu",
  in_bearbeitung: "In Bearbeitung",
  preisfreigabe_ausstehend: "Preisfreigabe ausstehend",
  wartet_auf_zahlung: "Wartet auf Zahlung",
  bezahlt: "Bezahlt",
  abgeschlossen: "Abgeschlossen",
  storniert: "Storniert",
  storniert_timeout: "Timeout storniert",
};

export const POSITION_STATUS_LABEL = {
  neu: "Neu",
  in_konstruktion: "In Konstruktion",
  in_druck: "In Druck",
  in_qs: "In QS",
  fertig: "Fertig",
};

export const TASK_TYPE_LABEL = {
  konstruktion: "Konstruktion", druck_vorbereitung: "Druck-Vorbereitung", druck: "Druck", qs: "QS",
  verpackung: "Verpackung", versand: "Versand", abrechnung: "Abrechnung", kundenkommunikation: "Kundenkommunikation", sonstiges: "Sonstiges",
  ueberweisung_rueckfrage: "Überweisung prüfen",
};
// System-Aufgaben (automatisch angelegt) – nicht manuell auswählbar
export const SYSTEM_TASK_TYPES = ["ueberweisung_rueckfrage"];
export const taskTypeLabel = (typ) => TASK_TYPE_LABEL[typ] || (typ ? `Sonstiges (${typ})` : "Sonstiges");

export const POSITION_TYPE_LABEL = {
  "3d_druck": "3D-Druck",
  cad_konstruktion: "CAD-Konstruktion",
  scan: "Scan",
  sonstiges: "Sonstiges",
  versand: "Versand",
};

export const ROLE_LABEL = {
  viewer: "Betrachter",
  employee: "Mitarbeiter",
  versand: "Versand",
  buchhaltung: "Buchhaltung",
  manager: "Manager",
  admin: "Administrator",
};

export const INQUIRY_STATUS_LABEL = {
  neu: "Neu",
  in_pruefung: "In Prüfung",
  in_auftrag_umgewandelt: "In Auftrag umgewandelt",
  abgelehnt: "Abgelehnt",
};

export const INQUIRY_SOURCE_LABEL = {
  wordpress: "WordPress",
  website: "Website",
  manuell: "Manuell",
  telefon: "Telefon",
  vor_ort: "Vor Ort",
};

export const EMAIL_STATUS_LABEL = {
  pending: "Wartend",
  sent: "Gesendet",
  failed: "Fehlgeschlagen",
  cancelled: "Storniert",
};

export const DAY_LABEL = {
  mon: "Montag", tue: "Dienstag", wed: "Mittwoch", thu: "Donnerstag",
  fri: "Freitag", sat: "Samstag", sun: "Sonntag",
};
export const DAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export function fmtEUR(n) {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0));
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("de-DE", { dateStyle: "medium", timeStyle: "short" }).format(new Date(iso));
  } catch { return iso; }
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("de-DE", { dateStyle: "medium" }).format(new Date(iso));
  } catch { return iso; }
}
